import { render, staticRenderFns } from "./LogoBrand.vue?vue&type=template&id=3528b4ec&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\4g22\\themes\\foreground-theme-2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3528b4ec')) {
      api.createRecord('3528b4ec', component.options)
    } else {
      api.reload('3528b4ec', component.options)
    }
    module.hot.accept("./LogoBrand.vue?vue&type=template&id=3528b4ec&", function () {
      api.rerender('3528b4ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/svg/LogoBrand.vue"
export default component.exports